(() => {
  const CARD_ADDON_VARIANT_ID = 50963040862506;
  const GIFT_ID_PROPERTY = '_JF Gift ID';
  const pendingByVariant = new Map();

  // Reuse Dawn's own desktop sticky-column behavior without rewriting product.json.
  document.querySelectorAll('.product__info-container').forEach((container) => {
    container.classList.add('product__column-sticky');
  });

  const isArabic = () => (document.documentElement.lang || '').toLowerCase().startsWith('ar');

  function message(key) {
    const copy = {
      deliveryDate: { en: 'Please choose a delivery date.', ar: 'يرجى اختيار تاريخ التوصيل.' },
      deliveryTime: { en: 'Please choose a delivery time.', ar: 'يرجى اختيار وقت التوصيل.' },
      cardError: {
        en: 'We could not add your selected card. Your gift is in the cart; please review it before checkout.',
        ar: 'تعذر إضافة البطاقة التي اخترتها. تمت إضافة الهدية إلى السلة؛ يرجى مراجعتها قبل إتمام الطلب.'
      }
    };
    return copy[key][isArabic() ? 'ar' : 'en'];
  }

  function selectedPaidCard(form) {
    const field = form.querySelector('[name="properties[Card]"]');
    const value = (field?.value || '').trim();
    if (!value || value.toLowerCase() === 'no card') return '';
    return value;
  }

  function ensureGiftId(form, hasPaidCard) {
    let input = form.querySelector(`[name="properties[${GIFT_ID_PROPERTY}]"]`);
    if (!hasPaidCard) {
      if (input) input.remove();
      return '';
    }
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = `properties[${GIFT_ID_PROPERTY}]`;
      form.appendChild(input);
    }
    if (!input.value) {
      input.value = (window.crypto && typeof window.crypto.randomUUID === 'function')
        ? window.crypto.randomUUID()
        : `jf-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    }
    return input.value;
  }

  function validateGiftFields(form) {
    const date = form.querySelector('[name="properties[Delivery Date]"]');
    const time = form.querySelector('[name="properties[Delivery Time]"]');
    if (!date || !time) return true;
    date.setCustomValidity('');
    time.setCustomValidity('');
    if (!date.value) {
      date.setCustomValidity(message('deliveryDate'));
      date.reportValidity();
      date.focus();
      return false;
    }
    if (!date.checkValidity()) {
      date.reportValidity();
      date.focus();
      return false;
    }
    if (!time.value) {
      time.setCustomValidity(message('deliveryTime'));
      time.reportValidity();
      time.focus();
      return false;
    }
    if (!time.checkValidity()) {
      time.reportValidity();
      time.focus();
      return false;
    }
    return true;
  }

  async function addPaidCard(cardType, cardMessage, giftId) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{
          id: CARD_ADDON_VARIANT_ID,
          quantity: 1,
          properties: {
            'Card Type': cardType,
            'Card Message': cardMessage || '',
            [GIFT_ID_PROPERTY]: giftId || ''
          }
        }]
      })
    });
    if (!res.ok) throw new Error('Paid card add-on failed');
    return res.json();
  }

  function setDirectButtonBusy(form, busy) {
    const button = form.querySelector('[data-jf-buy-now]');
    if (!button) return;
    button.disabled = Boolean(busy);
    button.toggleAttribute('aria-busy', Boolean(busy));
  }

  function clearDirectState(form) {
    delete form.dataset.jfDirectCheckout;
    delete form.dataset.jfPreExistingCartCount;
  }

  document.addEventListener('input', (event) => {
    if (event.target?.matches('[name="properties[Delivery Date]"], [name="properties[Delivery Time]"]')) event.target.setCustomValidity('');
  });
  document.addEventListener('change', (event) => {
    if (event.target?.matches('[name="properties[Delivery Date]"], [name="properties[Delivery Time]"]')) event.target.setCustomValidity('');
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-jf-buy-now]');
    if (!button) return;
    const form = button.closest('form[data-type="add-to-cart-form"]');
    if (!form) return;
    event.preventDefault();
    if (!validateGiftFields(form)) return;
    form.dataset.jfDirectCheckout = 'true';
    setDirectButtonBusy(form, true);

    const submitButton = form.querySelector('button[type="submit"][name="add"]');
    if (submitButton) {
      form.requestSubmit(submitButton);
    } else {
      setDirectButtonBusy(form, false);
      clearDirectState(form);
    }
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form || form.getAttribute('data-type') !== 'add-to-cart-form') return;
    const date = form.querySelector('[name="properties[Delivery Date]"]');
    const time = form.querySelector('[name="properties[Delivery Time]"]');
    if (!date || !time) return;
    if (!validateGiftFields(form)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      setDirectButtonBusy(form, false);
      clearDirectState(form);
      return;
    }
    const variantId = String(form.querySelector('input[name="id"]')?.value || '');
    if (!variantId) {
      setDirectButtonBusy(form, false);
      clearDirectState(form);
      return;
    }
    const cardType = selectedPaidCard(form);
    const giftId = ensureGiftId(form, Boolean(cardType));
    const cardMessage = (form.querySelector('[name="properties[Card Message]"]')?.value || '').trim();
    pendingByVariant.set(variantId, {
      form,
      cardType,
      cardMessage,
      giftId,
      directCheckout: form.dataset.jfDirectCheckout === 'true'
    });
  }, true);

  const hasPubSub = typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined';
  if (hasPubSub) {
    subscribe(PUB_SUB_EVENTS.cartError, (event) => {
      const variantId = String(event?.productVariantId || '');
      const pending = pendingByVariant.get(variantId);
      if (!pending) return;
      pendingByVariant.delete(variantId);
      setDirectButtonBusy(pending.form, false);
      clearDirectState(pending.form);
    });

    subscribe(PUB_SUB_EVENTS.cartUpdate, async (event) => {
      if (event?.source !== 'product-form') return;
      const variantId = String(event?.productVariantId || '');
      const pending = pendingByVariant.get(variantId);
      if (!pending) return;
      pendingByVariant.delete(variantId);
      try {
        if (pending.cardType) await addPaidCard(pending.cardType, pending.cardMessage, pending.giftId);
        if (pending.directCheckout) {
          window.location.assign('/cart');
          return;
        }
        if (pending.cardType) {
          window.location.assign('/cart');
          return;
        }
      } catch (error) {
        console.error('JF gifting flow error:', error);
        alert(message('cardError'));
        window.location.assign('/cart');
        return;
      } finally {
        setDirectButtonBusy(pending.form, false);
        clearDirectState(pending.form);
      }
    });
  }
})();

(() => {
  const observedButtons = new WeakSet();

  function getUnavailableLabels() {
    return [window.variantStrings?.soldOut, window.variantStrings?.unavailable]
      .filter(Boolean)
      .map((label) => String(label).trim());
  }

  function isUnavailableButton(button) {
    if (!button?.disabled) return false;
    const label = (button.querySelector('span')?.textContent || button.textContent || '').trim();
    return getUnavailableLabels().includes(label);
  }

  function setUnavailableState(form, unavailable) {
    const infoContainer = form.closest('.product__info-container');
    const controls = [
      form.querySelector('.jf-addons'),
      infoContainer?.querySelector('[id^="Quantity-Form-"]'),
      form.querySelector('[data-jf-buy-now]')
    ];

    controls.forEach((element) => {
      if (!element) return;
      element.hidden = Boolean(unavailable);
    });
  }

  function syncForm(form) {
    const submitButton = form.querySelector('[id^="ProductSubmitButton-"]');
    setUnavailableState(form, isUnavailableButton(submitButton));
  }

  function bindForm(form) {
    const submitButton = form.querySelector('[id^="ProductSubmitButton-"]');
    if (!submitButton) return;

    syncForm(form);
    if (observedButtons.has(submitButton)) return;
    observedButtons.add(submitButton);

    const observer = new MutationObserver(() => syncForm(form));
    observer.observe(submitButton, {
      attributes: true,
      attributeFilter: ['disabled'],
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  function bindAll() {
    document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(bindForm);
  }

  bindAll();
  document.addEventListener('product-info:loaded', bindAll);

  if (
    typeof subscribe === 'function'
    && typeof PUB_SUB_EVENTS !== 'undefined'
    && PUB_SUB_EVENTS.variantChange
  ) {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const sectionId = event?.data?.sectionId;
      const html = event?.data?.html;
      if (!sectionId || !html) return;

      const liveSubmit = document.getElementById(`ProductSubmitButton-${sectionId}`);
      const form = liveSubmit?.closest('form[data-type="add-to-cart-form"]');
      const sourceSubmit = html.getElementById(`ProductSubmitButton-${sectionId}`);
      if (!form || !sourceSubmit) return;

      setUnavailableState(form, sourceSubmit.hasAttribute('disabled'));
    });
  }
})();

(() => {
  const lang = (document.documentElement.lang || '').toLowerCase();
  if (!lang.startsWith('ar')) return;

  const localizeCompleteGiftHeading = () => {
    document.querySelectorAll('.complementary-products .accordion__title').forEach((heading) => {
      if ((heading.textContent || '').trim() === 'Complete the Gift') {
        heading.textContent = 'أكمل الهدية';
      }
    });
  };

  localizeCompleteGiftHeading();
  const observer = new MutationObserver(localizeCompleteGiftHeading);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
